/**
 * Circle can be rendered in these types
 */
export var CircleType;

(function (CircleType) {
  CircleType["Full"] = "FULL";
  CircleType["Outline"] = "OUTLINE";
})(CircleType || (CircleType = {}));